import {
  AlphabetCollectionsDraftApi,
  SharedserviceMelcoModelsAlphabetCollection,
  useAPIAction,
} from "melco-shared-logic";
import { useFormikContext } from "formik";
import { QueryObserverResult } from "react-query";
import { fontCollectionToInitialValues } from "../../../components/libraries/fontCollections/FontCollectionDetailForm";

export const useRevertFontCollection = (
  fontCollectionId: string,
  refetch: () => Promise<
    QueryObserverResult<SharedserviceMelcoModelsAlphabetCollection, unknown>
  >
) => {
  const { resetForm } = useFormikContext();

  return useAPIAction(
    AlphabetCollectionsDraftApi,
    async (api) => {
      const data = await api.userAlphabetCollectionsRevert({
        id: fontCollectionId,
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "libraries.font_collections.detail.revert",
      onSuccess: async () => {
        const refetchResult = await refetch();

        resetForm({
          values: refetchResult.data
            ? fontCollectionToInitialValues(refetchResult.data)
            : {},
        });
      },
    }
  );
};
